const REACT_APP_ENV = process.env.REACT_APP_ENV;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const MELI_APP_SCOPES = process.env.REACT_APP_MELI_APP_SCOPES;
const REBILL_DOMAIN = "rebill.to";
const URL_SCHEME = REACT_APP_ENV === "production" ? "https://" : "http://";

export {
  BACKEND_URL,
  REACT_APP_ENV,
  REBILL_DOMAIN,
  URL_SCHEME,
  MELI_APP_SCOPES,
};
